import { Button } from "@ravalmatic/catafractum-utils";
import { AudioManager } from "../../AudioManager";
import { GameVars } from "../../GameVars";

export class AudioButtonsContainer extends Phaser.GameObjects.Container {

    private soundtrackOnButton: Button;
    private soundtrackOffButton: Button;
    private sfxOnButton: Button;
    private sfxOffButton: Button;

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.x = GameVars.gameWidth - 110;
        this.y = 60 * GameVars.scaleY;
        this.scaleY = GameVars.scaleY;

        this.soundtrackOnButton = this.createAudioButton(scene, "btn_soundtrack_on", this.onClickMusicButton);
        this.soundtrackOffButton = this.createAudioButton(scene, "btn_soundtrack_off", this.onClickMusicButton);
        this.sfxOnButton = this.createAudioButton(scene, "btn_sfx_on", this.onClickSfxButton);
        this.sfxOffButton = this.createAudioButton(scene, "btn_sfx_off", this.onClickSfxButton);

        this.soundtrackOnButton.x = -50;
        this.soundtrackOffButton.x = -50;
        this.sfxOnButton.x = 50;
        this.sfxOffButton.x = 50;

        this.add([
            this.soundtrackOnButton,
            this.soundtrackOffButton,
            this.sfxOnButton,
            this.sfxOffButton
        ]);
        this.refresh();
    }

    public refresh(): void {

        this.soundtrackOnButton.setVisible(!GameVars.gameData.musicMuted);
        this.soundtrackOffButton.setVisible(GameVars.gameData.musicMuted);
        this.sfxOnButton.setVisible(!GameVars.gameData.sfxMuted);
        this.sfxOffButton.setVisible(GameVars.gameData.sfxMuted);
    }

    private createAudioButton(scene: Phaser.Scene, frame: string, callback: () => void): Button {

        const button = new Button(scene, 0, 0, "texture_atlas_1", frame);
        button.setInflationTween(1.05);
        button.on("pointerdown", callback, this);
        return button;
    }

    private onClickMusicButton(): void {

        AudioManager.toggleMusicState();
        this.refresh();
        AudioManager.playSound("audio-btns", false);
    }

    private onClickSfxButton(): void {

        AudioManager.toggleSfxState();
        this.refresh();
    }
}
